import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import { activeServiceData } from "assets/properties/properties";
const ThirdPartyCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [name, setName] = useState("");
  const [disabledButton, setDisabledButton] = useState(true);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [enabledSerive, setEnabledService] = useState("");
  const [thirdPartyName, setThirdPartyName] = useState("");
  const [vendorNameList,setVendorNameList] = useState([]);
  const outletData = useOutletContext();
  const thirdPartyServiceNameFlag = typeof outletData?.thirdPartyServiceNameFlag === "string" ? JSON.parse(outletData?.thirdPartyServiceNameFlag) : outletData?.thirdPartyServiceNameFlag;
  useEffect(() => {
    (async () => {
      if (params?.id) {
        // Get Data from API
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.THIRD_PARTY_FINDALL,
          authToken: authToken,
        });
        setCallInProgress(false);
        const filteredData = result?.data?.filter((item) => item?.id === Number(params?.id));
        if (filteredData?.length > 0) {
            setName(filteredData[0].integration);
            setEnabledService(filteredData[0].enabled);
            setThirdPartyName(filteredData?.[0]?.vendor)
        }
      }
    })();
  }, []);

  useEffect(() => {
    let isEnabled;
    if (enabledSerive === '' || enabledSerive === null || enabledSerive === undefined) {
      isEnabled = '';
    } else {
      isEnabled = enabledSerive === true || enabledSerive === 'true';
    }
    if ((isEnabled !== "" && name && thirdPartyName) || (isEnabled === false && name) || (name === 'SMS' && thirdPartyName)) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [name, enabledSerive, thirdPartyName]);

  useEffect(()=>{
    if(name){
      findVendorNameList();
    }
  },[name])

  const findVendorNameList = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.THIRD_PARTY_VENDORS_FIND + name,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
    } else {
      setVendorNameList(res?.data?.vendors);
    }
  } 
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const editInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.THIRD_PARTY_UPDATE, 
      method: "POST",
      authToken: authToken,
      data: {
        integration:name,
        enabled:name === "SMS" ? true : enabledSerive,
        vendor:thirdPartyName,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const saveInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.THIRD_PARTY_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        integration:name,
        enabled:name === "SMS" ? true : enabledSerive,
        vendor:thirdPartyName,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description,true);
      return "ERROR";
    } else {
      return "SUCCESS";
    }
  };
  const handleDiscrepancySubmit = async (event) => {
    toastUpdate("", "",false);
      let status = "";
      if (params.id) {
        status = await editInformation();
      } else {
        status = await saveInformation();
      }
      if (status === "SUCCESS") {
        const msg = params.id
          ? "Third Party updated successfully!"
          : "Third Party created successfully!";
          toastUpdate("Success", msg,true);
        setRedirectURL(`/coreservice/ThirdParty`);
      }
  };
  const handleCancel = () => {
    navigate("/coreservice/ThirdParty");
  };
  const enabledService = (e)=>{
    setEnabledService(e)
    if(e === "false"){
      setThirdPartyName("")
    }
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.id ? "Edit Third Party" : "Create Third Party"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
              label="Service Name*"
              id="name"
              value={name}
              setState={setName}
              data={thirdPartyServiceNameFlag}
              type="TYPE"
            />
          </Grid>
          {name !== 'SMS' &&
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
              label="Enabled*"
              id="dependancy"
              value={enabledSerive}
              setState={enabledService}
              data={activeServiceData}
              type="bool"
            />
          </Grid>
          }
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
              label="Vendor Name*"
              id="thirdPartyName"
              value={thirdPartyName}
              setState={setThirdPartyName}
              data={vendorNameList}
              type="nameFormat"
              disabled={vendorNameList?.length < 1 || name !== "SMS" && (enabledSerive === "" || enabledSerive === "false")}
            />
          </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default ThirdPartyCreate;
